// Copyright (c) 2017 Deere & Company

import PrepareAudit from '../../tcsm/prepare-audit/state-connector';
import auditAddClaims from './audit-add-claims';

export default {
    childRoutes: [auditAddClaims],
    component: PrepareAudit,
    keepQueryParams: true,
    name: 'PREPARE_AUDIT',
    path: 'audits/prepare'
};



// WEBPACK FOOTER //
// ./src/routes/tcsm/prepare-audit.js